module.exports = __webpack_public_path__ + "img/tokenpost.c164d490.png";